import React from 'react'
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import { Rating } from "@mui/material";
import {APP_STATUS, APP_STATUS_VERBOSE} from "../../../../utils/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
const DQRatedProgram = ({ data, actions, options }) => {
    const classes = useStyles();
    const { programStatus, programStatusV3 } = data;
    const { ViewReportAction } = actions;
    const { } = options;

    const handleViewReport = () => {
        ViewReportAction();
    };
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "87vh",
                    padding: 4,
                }}
            >
                <Typography variant="h3" sx={{ marginBottom: 5}} className={classes.title}>
                    View Your Available Report
                </Typography>
                {
                    (
                        programStatusV3 !== APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED &&
                        programStatusV3 !== APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED &&
                        programStatusV3 !== APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED &&
                        programStatus !== APP_STATUS.WITHDRAWN &&
                        programStatus !== APP_STATUS.REJECTED &&
                        programStatus !== APP_STATUS.HALTED_COLLECT_DATA &&
                        programStatus !== APP_STATUS.HALTED_PROCESS_DATA &&
                        programStatus !== APP_STATUS.HALTED_REPORT
                    ) && (
                        <CircularProgress className={classes.loader}/>
                    )
                }
                <br/>
                <Box sx={{flexDirection:{sm:'row', xs:'column'},marginBottom: 4,}} style={{display:'flex', alignItems:'center',}}>
                <Typography variant="body1" sx={{marginBottom:{xs:'1', sm:'4'}, textAlign: 'center', fontSize: '25px !important', color: '#ED6628'}}>
                    Status:
                </Typography><Typography variant="body1" className={classes.status} sx={{marginLeft:2}}>
                    {
                        programStatus === APP_STATUS.WITHDRAWN ||
                        programStatus === APP_STATUS.REJECTED ||
                        programStatus === APP_STATUS.HALTED_COLLECT_DATA ||
                        programStatus === APP_STATUS.HALTED_PROCESS_DATA ||
                        programStatus === APP_STATUS.HALTED_REPORT
                            ? APP_STATUS_VERBOSE[APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED]
                            : APP_STATUS_VERBOSE[programStatusV3]
                    }
                </Typography>
                </Box>
                <Box className={classes.cardsContainer}>
                    <Card
                        sx={{
                            width: "350px",
                            borderRadius: "12px",
                            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",
                            textAlign: "center",
                            padding: 2,
                            backgroundColor: "#fff",
                        }}
                    >
                        {/*<Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                        {/*    <Rating*/}
                        {/*        value={2}*/}
                        {/*        max={3}*/}
                        {/*        readOnly*/}
                        {/*        icon={<span style={{color: "#FFD700", fontSize: "80px"}}>★</span>}*/}
                        {/*        emptyIcon={<span style={{color: "#E0E0E0", fontSize: "80px"}}>★</span>}*/}
                        {/*    />*/}
                        {/*</Box>*/}
                        <Typography variant="h4" sx={{marginTop: 2, }} className={classes.cardTitle}>
                          DQ Alignment Report
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#666",marginBottom: 4 }}>
                            This alignment showcases how comprehensive your program’s content is against
                            the DQ’s Cyber Citizenship Framework.
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                marginBottom: 2,
                                textTransform: "none",
                                background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",
                                color: '#fff',
                                '&:hover': {
                                    background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",
                                },
                                "&.Mui-disabled": {
                                    background: "linear-gradient(to left, #D3D3D3 35%, #A9A9A9 190%) !important",
                                    color: "#767676 !important",
                                },
                            }}
                            disabled={programStatusV3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED}
                            onClick={handleViewReport}
                        >
                            View Report
                        </Button>
                    </Card>

                    {/*<Card*/}
                    {/*    sx={{*/}
                    {/*        width: "350px",*/}
                    {/*        borderRadius: "12px",*/}
                    {/*        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",*/}
                    {/*        textAlign: "center",*/}
                    {/*        padding: 2,*/}
                    {/*        backgroundColor: "#fff",*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                    {/*        <Rating*/}
                    {/*            value={0}*/}
                    {/*            max={3}*/}
                    {/*            readOnly*/}
                    {/*            icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}*/}
                    {/*            emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}*/}
                    {/*        />*/}
                    {/*    </Box>*/}

                    {/*    <Typography variant="h4" className={classes.cardTitle}>*/}
                    {/*        Digital-Safety-by-Design Rating*/}
                    {/*    </Typography>*/}

                    {/*    <Typography variant="body1" sx={{ color: "#666", marginTop: 2, marginBottom: 4 }}>*/}
                    {/*        Check your program’s Digital-Safety-by-Design rating to see what*/}
                    {/*        regulations your program complies with locally and globally.*/}
                    {/*    </Typography>*/}
                    {/*    <Button*/}
                    {/*        variant="contained"*/}
                    {/*        sx={{*/}
                    {/*            marginBottom: 2,*/}
                    {/*            textTransform: "none",*/}
                    {/*            background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",*/}
                    {/*            color: '#fff',*/}
                    {/*            '&:hover': {*/}
                    {/*                background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",*/}
                    {/*            },*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        Check Rating*/}
                    {/*    </Button>*/}
                    {/*</Card>*/}
                </Box>
            </Box>
        </>
    );
}

export default DQRatedProgram;